'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState, useCallback, useEffect } from 'react';
import { TooltipContainer, TooltipLabelElement } from './elements';
import { getTooltipClass } from './utils';
export const Tooltip = ({
  label,
  position = 'top',
  variant = 'dark',
  maxWidth,
  children,
  containerClassName,
  ...rest
}) => {
  const [show, setShow] = useState(false);
  const [targetDimensions, setTargetDimensions] = useState({
    width: 0,
    height: 0
  });
  const [tooltipDimensions, setTooltipDimensions] = useState({
    height: 0,
    width: 0
  });
  const resizeTooltip = useCallback(el => {
    if (el) {
      setTooltipDimensions({
        height: el.clientHeight,
        width: el.clientWidth
      });
    }
  }, []);
  const getPosition = e => {
    const {
      width,
      height
    } = e.currentTarget.getBoundingClientRect();
    setTargetDimensions({
      width,
      height
    });
    setShow(true);
  };
  const hideTooltip = () => setShow(false);
  const escKeyHandler = React.useCallback(e => {
    if (e.key === 'Escape') {
      hideTooltip();
    }
  }, []);
  useEffect(() => {
    document.addEventListener('keydown', escKeyHandler, false);
    return () => {
      document.removeEventListener('keydown', escKeyHandler, false);
    };
  }, [escKeyHandler]);
  return /*#__PURE__*/React.createElement(TooltipContainer, {
    className: containerClassName,
    onMouseOver: getPosition,
    onFocus: getPosition,
    onMouseLeave: hideTooltip,
    onBlur: hideTooltip
  }, show && label.trim() !== '' && /*#__PURE__*/React.createElement(TooltipLabelElement, _extends({
    "data-aui": "tooltip"
  }, rest, {
    $position: position,
    $targetDimensions: targetDimensions,
    $dimensions: tooltipDimensions,
    $variant: variant,
    $maxWidth: maxWidth,
    className: getTooltipClass(position),
    ref: resizeTooltip
  }), label), children);
};